<template>
  <div class="darkAdminHomeContainer" ref="adminHomeContainer">
    <el-container direction="vertical" style="width: 100%; height: 100%">
      <el-header
        class="adminHomeHeader"
        style="width: 100%; height: 80px; padding: 0px; margin: 0px;"
      >
        <div class="left">
          <div class="left-container">低空智能管控系统</div>
        </div>

        <div class="right">
          <!-- <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" class="photo" /> -->
          <div class="usernameDiv">
            <el-dropdown
              ref="dropdown"
              :hide-on-click="false"
              trigger="click"
              @click.native="changeMoreClass"
            >
              <span class="username">
                {{ userInfo.userNo }}
              </span>
              <el-dropdown-menu slot="dropdown" class="dropdown adminHomeUserMenu">
                <el-dropdown-item>
                  <a @click="LogOut">退出登录</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div :class="moreClass" @mouseover="mouseOver" @click="clickMore"></div>
        </div>
      </el-header>

      <el-container style="height: calc(100% - 80px); width: 100%">
        <!-- <el-aside
          width="249px"
          style="
            height: 100%;
            box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.06);
            overflow-x: hidden;
          "
        >
          <el-menu
            :unique-opened="true"
            :default-active="navselected"
            :active="navselected"
            @open="handleOpen"
            @close="handleClose"
            @select="handleMenuSelect"
          >
            <menutree :data="menuList"></menutree>
          </el-menu>
          <el-button icon="el-icon-back-home" class="backHomeBtn" @click="toHomePage"
            >返回主页</el-button
          >
        </el-aside> -->

        <el-main style="width: 100%; height: 100%; padding: 0px 40px">
          <!-- <div class="nav-header-container">
            <div class="nav-header">
              <div class="breadcrumb" v-html="breadcrumbHtml"></div>
            </div>
            <div class="nav-header-separator"></div>
          </div> -->
          <div class="nav-main-container">
            <el-tabs
              v-model="currentTab"
              @tab-remove="removeTab"
              @tab-click="handleClick"
            >
              <el-tab-pane
                v-for="menu in functionsOfHome"
                :label="menu.name"
                :name="menu.path"
                :key="menu.id"
              >
                <Dashboard
                  v-if="menu.path === 'dashboard'"
                  :functions="functions"
                  @handleSubMenuSelect="handleSubMenuSelect"
                ></Dashboard>
                <User
                  ref="user"
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-if="menu.path === 'user'"
                ></User>
                <Department
                  ref="department"
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'department'"
                ></Department>
                <Permission
                  ref="permission"
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'permission'"
                ></Permission
                ><Role
                  ref="role"
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'role'"
                ></Role
                ><AreaCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'areaList'"
                ></AreaCompent>
                <StationCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'stationList'"
                ></StationCompent>
                <Airport
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'airportList'"
                ></Airport>
                <StayPointCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'stayPointList'"
                ></StayPointCompent>
                <CompanyCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'companyList'"
                ></CompanyCompent>
                <PlaneModelCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'planeType'"
                ></PlaneModelCompent>
                <PlaneCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'planeList'"
                ></PlaneCompent>
                <LinkCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'linkList'"
                ></LinkCompent>
                <ComStationCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'comStationList'"
                ></ComStationCompent>

                <!-- 图元信息组件 -->
                <elementManagementCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'elementManagement'"
                ></elementManagementCompent>

                <!-- 历史任务管理组件 -->
                <historicalTaskManagementCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'historicalTaskManagement'"
                ></historicalTaskManagementCompent>

                <!-- 飞行记录管理组件 -->
                <flightRecordManagementCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'flightRecordManagement'"
                ></flightRecordManagementCompent>

                <!-- 视频数据管理组件 -->
                <videoDataManagementCompent
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'videoDataManagement'"
                ></videoDataManagementCompent>

                <!-- 数据统计组件 -->
                <DataStatistics
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'dataStatistics'"
                ></DataStatistics>

                <!-- 日志管理 -->
                <LogManage
                  ref="logManage"
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'logManage'"
                ></LogManage>
                <Config
                  ref="configManage"
                  @getMenuList="getMenuList"
                  :menuId="menu.id"
                  v-else-if="menu.path === 'config'"
                ></Config>

                <Waiting v-else-if="'' !== menu.path"></Waiting>
              </el-tab-pane>
            </el-tabs>
            <el-button class="backHomeBtn" @click="toHomePage">
              返回主页
            </el-button>
            <el-button class="clearRecord" @click="clearRecord">
              清除航迹
            </el-button>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
import menutree from "../tools/menutree.vue";
import Dashboard from "./dashboard";
import Airport from "./airport/airport.vue";
import AreaCompent from "./area/area.vue";
import StayPointCompent from "./stayPoint/stayPoint.vue";
import LinkCompent from "./link/airLink.vue";
import ComStationCompent from "./link/comStation.vue";
import elementManagementCompent from "./management/elementManagement.vue";
import historicalTaskManagementCompent from "./management/historicalTaskManagement.vue";
import flightRecordManagementCompent from "./management/flightRecordManagement.vue";
import videoDataManagementCompent from "./management/videoDataManagement.vue";
import PlaneCompent from "./plane/plane/plane.vue";
import PlaneModelCompent from "./plane/model/model.vue";
import CompanyCompent from "./company/company.vue";
import StationCompent from "./area/station.vue";
import Department from "./user/department";
import Permission from "./user/permission";
import Role from "./user/role";
import LogManage from "./user/logManage";
import Config from "./user/config";
import User from "./user/user";
import DataStatistics from "./statistics/dataStatistics";
import Waiting from "./waiting";
const defaultBreadcrumb = "<span class='default-breadcrumb'>";
export default {
  name: "adminHome",
  data() {
    return {
      menuList: [], //侧边菜单
      navselected: "",
      defaultBreadcrumb: "",
      breadcrumbHtml: "",
      currentTab: "",
      tabMenus: {},
      tabList: [], //显示的tab
      userInfo: {},
      functions: [], //仪表盘菜单列表
      functionsOfHome: [], //首页菜单列表
      moreClass: "moreBefore",
      adminHomeClassName: "dark", //后端样式
    };
  },
  beforeMount() {
    this.findChildrenByParentId();
  },
  mounted() {
    this.getUserInfo();
    const body = document.getElementsByTagName("body")[0];
    body.classList.add(
      this.$data.adminHomeClassName + "AdminHomeBodyContainer"
    );
  },
  methods: {
    vIfContains(path) {
      if (this.tabList.indexOf(path) >= 0) {
        return true;
      }
      return false;
    },
    findChildrenByParentId() {
      let adminHomeId = sessionStorage.getItem("adminHomeId");
      if (adminHomeId) {
        this.getRequest(
          "/user-server/api/u-permission/findChildrenByParentId?pid=" +
            adminHomeId +
            "&type=0&status=0"
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data && data[0]) {
              let menuList = data[0].children;
              this.menuList = menuList;
              this.tabMenus = {};
              if (menuList && menuList.length > 0) {
                let name = menuList[0].name;
                let defaultBreadcrumbs = defaultBreadcrumb + name + "</span>";
                this.defaultBreadcrumb = defaultBreadcrumbs;
                this.breadcrumbHtml = defaultBreadcrumbs;

                let path = menuList[0].path;
                this.currentTab = path;
                this.tabList.push(path);
                this.navselected = String(menuList[0].id);
                this.insertTabMenu(menuList);
              }
            } else {
              this.menuList = [];
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      }
    },
    insertTabMenu(menuList) {
      if (menuList && menuList.length > 0) {
        menuList.forEach((item) => {
          let name = item.name;
          let path = item.path;
          let id = item.id;
          let pid = item.pid;
          let seq = item.seq;
          let key = pid + "-" + seq;
          this.tabMenus[path] = key;
          this.tabMenus[path + "-id"] = id + "";
          this.tabMenus[key + "-path"] = path;
          this.tabMenus[id] = name;
          this.tabMenus[id + "-path"] = path;
          this.tabMenus[key + "-name"] = name;
          if (item.children && item.children.length > 0) {
            let children = item.children;
            children.forEach((child) => {
              this.insertDataTabMenu(child);
            });
          } else {
            if ("dashboard" !== path) {
              this.functions.push(item);
            }
            this.functionsOfHome.push(item);
          }
        });
      }
      //暂时隐藏巡检计划申请
      this.functionsOfHome=this.functionsOfHome.filter(v=>v.path!=='/inspectionPlan')
    },
    insertDataTabMenu(item) {
      let name = item.name;
      let path = item.path;
      let id = item.id;
      let pid = item.pid;
      let seq = item.seq;
      let key = pid + "-" + seq;
      this.tabMenus[path] = key;
      this.tabMenus[path + "-id"] = id + "";
      this.tabMenus[key + "-path"] = path;
      this.tabMenus[id] = name;
      this.tabMenus[id + "-path"] = path;
      this.tabMenus[key + "-name"] = name;
      if (item.children && item.children.length > 0) {
        let children = item.children;
        children.forEach((child) => {
          this.insertDataTabMenu(child);
        });
      } else {
        if ("dashboard" !== path) {
          this.functions.push(item);
        }
        this.functionsOfHome.push(item);
      }
    },
    getUserInfo() {
      let userNo = sessionStorage.getItem("userName");
      if (userNo) {
        let params = {
          userNo,
          removed: 0,
        };
        this.postJsonRequest(
          "/user-server/api/u-user/getUsersByCondition",
          params
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data && data.length > 0) {
              this.userInfo = data[0];
              if (this.userInfo.iconUrl) {
                this.userInfo.iconUrl = "/minio/" + this.userInfo.iconUrl;
              } else {
                this.userInfo.iconUrl = null;
              }
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      }
    },
    changeMoreClass() {
      let dropdown = this.$refs.dropdown;
      if (dropdown) {
        if (dropdown.visible) {
          this.moreClass = "moreBefore";
        } else {
          this.moreClass = "moreAfter";
        }
      }
    },
    mouseOver() {
      this.moreClass = "moreAfter";
      this.$refs.dropdown.show();
    },
    clickMore() {
      let dropdown = this.$refs.dropdown;
      if (dropdown) {
        if (dropdown.visible) {
          this.moreClass = "moreBefore";
          dropdown.hide();
        } else {
          this.moreClass = "moreAfter";
          dropdown.show();
        }
      }
    },
    LogOut() {
      let tips = "<i class='el-icon-warn-tip'></i>是否确定退出登录?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest("/token-server/api/logout").then((res) => {
            let oData = res.data;
            if (oData.code == 0) {
              window.sessionStorage.clear();
              this.$router.push({
                path: "/login",
              });
            } else {
              let tips = "<i class='el-icon-warn-tip'></i>退出登录失败";
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClick(tab) {
      console.log(this.$refs.role,2)
      //清除表单
      this.$refs.user?this.$refs.user[0]._data.queryForm.keywords = '':''
      this.$refs.department?this.$refs.department[0]._data.queryForm.keywords = '':''
      this.$refs.permission?this.$refs.permission[0]._data.queryForm.keywords = '':''
      this.$refs.role?this.$refs.role[0].queryForm.roleName = '':''
      this.$refs.logManage?(this.$refs.logManage[0]._data.queryForm.endTime = new Date())&&(this.$refs.logManage[0]._data.queryForm.startTime = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)):''
      let tabName = tab.name;
      if ("dashboard" === tabName) {
        this.$data.navselected = this.$data.tabMenus[tabName + "-id"];
      } else {
        this.$data.navselected = this.$data.tabMenus[tabName];
      }
      this.callCallbackMethod(tab.name); //重新设置表格的高宽
    },
    callCallbackMethod(name) {
      const methodName = "callOnTabSelect";
      const compent = this.searchCompentByName(name);
      if (compent && compent[methodName]) {
        compent.callOnTabSelect(); //调用重新设置表格样式的方法
      }
    },
    getIndex(key, index) {
      let tabMenus = this.$data.tabMenus;
      const path = tabMenus[key + "-" + index + "-path"];
      if (!path) {
        this.getIndex(key, ++index);
      }
      let value = key + "-" + index;
      return value;
    },
    handleOpen(key, keyPath) {
      let index = this.getIndex(key, 1);
      this.handleMenuSelect(index);
    },
    handleClose(key, keyPath) {
      this.handleMenuSelect("1");
    },
    handleSubMenuSelect(tabName) {
      this.handleMenuSelect(this.$data.tabMenus[tabName]);
    },
    handleMenuSelect(index) {
      this.$data.navselected = index;
      let tabMenus = this.$data.tabMenus;
      const path = tabMenus[index + "-path"];
      if (!this.isEmptyStr(path)) {
        this.$data.currentTab = path;
        this.addTab(path);
      }
    },
    setBreadcrumb: function (index) {
      let tabName;
      if (index) {
        let indexArr = index.split("-");
        let tabMenus = this.tabMenus;
        if (indexArr.length > 0) {
          let pName = [];
          for (let m = 0, len = indexArr.length; m < len; m++) {
            if (m !== len - 1) {
              let id = indexArr[m];
              pName.push(tabMenus[id]);
            }
          }

          tabName = tabMenus[index + "-name"];
          let path = tabMenus[index + "-path"];
          if ("dashboard" === path) {
            this.$data.breadcrumbHtml = this.$data.defaultBreadcrumb;
          } else {
            let dashboardIndex = tabMenus["dashboard"];
            let dashboardName = tabMenus[dashboardIndex + "-name"];
            const breadcrumbMenu = [
              dashboardName + "&nbsp;&nbsp;/&nbsp;&nbsp;",
            ];
            let breadcrumbHtml = "";
            if (pName.length > 0) {
              pName.forEach((p) => {
                breadcrumbMenu.push(p + "&nbsp;&nbsp;/&nbsp;&nbsp;");
              });
            }
            //breadcrumbHtml += this.getUnClickableBreadcrumb(breadcrumbMenu);
            breadcrumbHtml +=
              "<span class='clickable-breadcrumb'>" + tabName + "</span>";
            this.$data.breadcrumbHtml = breadcrumbHtml;
          }
        }
      }
      return tabName;
    },
    getUnClickableBreadcrumb(breadcrumbMenu) {
      let str = "";
      str += "<span class='unclickable-breadcrumb'>";
      breadcrumbMenu.forEach((element) => {
        str += element;
      });
      str += "</span>";
      return str;
    },
    addTab: function (tabName) {
      let flag = true;
      if (this.tabList.indexOf(tabName) < 0) {
        this.tabList.push(tabName);
        flag = false;
      }
      //调用重新设置表格样式的函数
      if (flag) {
        this.callCallbackMethod(tabName);
      }
    },
    removeTab(targetName, currentTabName) {
      currentTabName = this.$data.currentTab;
      let Iindex = 0;
      this.tabList.map((value, index, array) => {
        if (value === targetName) {
          Iindex = index;
          return false;
        }
      });
      this.tabList.splice(Iindex, 1);
      //如果删除的是选择的tab,需要重新选择一个tab
      if (targetName == this.$data.currentTab) {
        //删除的为选择的tab,选择最后一个tab作为选择的tab
        if (!this.isEmptyArray(this.$data.tabList)) {
          currentTabName = this.$data.tabList[this.$data.tabList.length - 1];
        }
      }
      this.currentTab = currentTabName;
      if ("dashboard" === currentTabName) {
        this.handleMenuSelect(this.$data.tabMenus[currentTabName + "-id"]);
      } else {
        this.handleMenuSelect(this.$data.tabMenus[currentTabName]);
      }
    },
    resetBreadcrumb(nval, oval) {
      let index;
      if (nval == oval) {
        return;
      } else if (null == nval) {
        index = "";
      } else {
        index = this.$data.tabMenus[nval];
      }
      this.setBreadcrumb(index);
    },
    toHomePage() {
      this.$router.push({ path: "/home" });
    },
    //清除航迹
    clearRecord(){
      this.getRequest(
        "/uav-task-server/point/clearMap"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            },
          });
        } else if (oData.code != 401) {

        }})
    },
    // 获取菜单列表
    getMenuList(pid, type, status, callback) {
      if (pid) {
        this.getRequest(
          "/user-server/api/u-permission/findChildrenByParentId?pid=" +
            pid +
            "&type=" +
            type +
            "&status=" +
            status
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            callback(oData.data);
          } else if (oData.code != 401) {
            // callback([]);
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      }
    },
  },
  components: {
    menutree,
    Dashboard,
    Airport,
    AreaCompent,
    StayPointCompent,
    CompanyCompent,
    LinkCompent,
    ComStationCompent,
    elementManagementCompent,
    historicalTaskManagementCompent,
    flightRecordManagementCompent,
    videoDataManagementCompent,
    PlaneCompent,
    PlaneModelCompent,
    StationCompent,
    Department,
    Permission,
    Role,
    User,
    Config,
    DataStatistics,
    Waiting,
    LogManage,
  },
  watch: {
    currentTab: function (nval, oval) {
      this.resetBreadcrumb(nval, oval);
    },
  },
  beforeDestroy() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove(
      this.$data.adminHomeClassName + "AdminHomeBodyContainer"
    );
  },
};
</script>

<style>
@import "../../assets/css/admin/adminHome.css";
</style>

<style>
@import "../../assets/css/admin/darkAdminHome.css";
</style>

<style scoped>
.adminHomeContainer .el-aside .el-menu,
.adminHomeContainer .nav-header-container {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
.el-dropdown-menu__item {
  font-size: 12px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/adminHome.vue